import { ApolloError } from '@apollo/client';
import React from 'react';
import { Loading, LoadingWithHeight } from 'src/shared/design-system/Loading';
import { NetworkingError } from 'src/shared/design-system/NetworkingError';

interface IProps {
  loading: boolean;
  error: ApolloError | undefined;
  errorMessage?: string;
}

export const GqlQueryWrapper: React.FC<React.PropsWithChildren<IProps>> = ({
  error,
  loading,
  errorMessage,
  children,
}) => {
  if (loading) {
    return <LoadingWithHeight />;
  }

  if (error) {
    console.error('Received error', error);
    return <NetworkingError error={error} message={errorMessage} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

interface IRenderProps<T> extends IProps {
  data: T;
  children: (data: NonNullable<T>) => JSX.Element;
}

/** @deprecated 2021-04-27 */
export function GqlQueryRender<T>({ error, loading, errorMessage, children, data }: IRenderProps<T>) {
  if (error) {
    console.error('Received error', error);
  }
  return loading ? (
    <Loading delayMs={500} />
  ) : error ? (
    <NetworkingError error={error} message={errorMessage} />
  ) : data ? (
    children(data as NonNullable<T>)
  ) : null;
}
